import React, {useEffect} from 'react'
import {Helmet} from 'react-helmet'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'
import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {routes} from 'routes/routes'
import {useQueryParams} from 'utils/lib/url'
import {RequestReset} from 'attendee/Auth/PasswordRecover/RequestReset'
import {ResetPassword} from 'attendee/Auth/PasswordRecover/ResetPassword'

export function PasswordRecover() {
  const {token} = useQueryParams()

  const navigate = useLocalizedNavigate()
  const {user} = useAuth()

  useEffect(() => {
    if (user) {
      navigate(routes.index)
    }
  }, [navigate, user])

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      {token ? <ResetPassword /> : <RequestReset />}
    </>
  )
}
